/* Component for easier ES6 binding */

import { Component } from 'react';

export default class BaseComponent extends Component {

	// The rest parameter syntax allows to represent an indefinite number of arguments as an array.
	// https://developer.mozilla.org/pl/docs/Web/JavaScript/Reference/Functions/rest_parameters
	_bind(...methods) {
		methods.forEach( (method) => this[method] = this[method].bind(this) );
	}

	setContent(id) {
		this.setState({ index : id })
	}

	setWrapperHeight(h) {
		this.props.setHeight(h)
	}
}

export function leadingZero(day) {
	let d = parseInt(day);
	if (d < 10) {
	  return "0" + d;
	} else {
	  return "" + d;
	}
  }
  
  export function parseDate(d, hours, showSeconds) {
	let date = new Date(d);
	let seconds = ":" + leadingZero(date.getSeconds());
  
	if (showSeconds === false) {
	  seconds = "";
	}
  
	if (hours) {
	  return (
		leadingZero(date.getDate()) +
		"/" +
		leadingZero(date.getMonth() + 1) +
		"/" +
		date.getFullYear() +
		", " +
		leadingZero(date.getHours()) +
		":" +
		leadingZero(date.getMinutes()) +
		seconds
	  );
	} else {
	  return (
		leadingZero(date.getDate()) +
		"." +
		leadingZero(date.getMonth() + 1) +
		"." +
		date.getFullYear()
	  );
	}
  }

export function errorInputValidator(error) {
	if(error?.includes("Validator")) {
		const type = error.split("/")[error.split("/").length-1].split("_")[0]
		const index = error.split("/")[error.split("/").length-1].split("_")[1]

		if(index) {
			setTimeout(() => { document.querySelector("[data-moduleindex='" + index + "'][data-moduletype='" + type + "']")?.scrollIntoView({behavior: "smooth", block: "center", inline: "center"})
				setTimeout(() => {
					document.querySelector("[data-moduleindex='" + index + "'][data-moduletype='" + type + "']")?.classList.add("input-error")
					if(document.querySelector("[data-moduleindex='" + index + "'][data-moduletype='" + type + "'] .ck-content")) {
						document.querySelector("[data-moduleindex='" + index + "'][data-moduletype='" + type + "'] .ck-content").focus()
					}
					setTimeout(() => {
						document.querySelector("[data-moduleindex='" + index + "'][data-moduletype='" + type + "']")?.classList.remove("input-error")
					}, 3000)
				}, 300)
			}, 300)
		} else {
			setTimeout(() => { document.querySelector("[data-moduletype='" + type + "']")?.scrollIntoView({behavior: "smooth", block: "center", inline: "center"})
				setTimeout(() => {
					document.querySelector("[data-moduletype='" + type + "']")?.classList.add("input-error")
					if(document.querySelector("[data-moduletype='" + type + "'] .ck-content")) {
						document.querySelector("[data-moduletype='" + type + "'] .ck-content").focus()
					}
					setTimeout(() => {
						document.querySelector("[data-moduletype='" + type + "']")?.classList.remove("input-error")
					}, 3000)
				}, 300)
			}, 300)
		}
	}
}
  
export function errorMap(error) {
	switch(error) {
		case "error_article_not_found": 
			return "error_article_not_found"
		case "error_articlecategory_in_use": 
			return "error_articlecategory_in_use"
		case "error_articlecategory_not_found": 
			return "error_articlecategory_not_found"
		case "error_entity_not_found": 
			return "error_entity_not_found"
		case "error_event_finish_before_start": 
			return "error_event_finish_before_start"
		case "error_event_not_found": 
			return "error_event_not_found"
		case "error_event_optin_after_start": 
			return "error_event_optin_after_start"
		case "error_event_optout_after_start": 
			return "error_event_optout_after_start"
		case "error_event_optout_before_optin": 
			return "error_event_optout_before_optin"
		case "error_faq_not_found": 
			return "error_faq_not_found"
		case "error_faqcategory_in_use": 
			return "error_faqcategory_in_use"
		case "error_faqcategory_not_found": 
			return "error_faqcategory_not_found"
		case "error_file_not_found": 
			return "error_file_not_found"
		case "error_file_size_exceeded": 
			return "error_file_size_exceeded"
		case "error_file_type_not_permitted": 
			return "error_file_type_not_permitted"
		case "error_history_not_found": 
			return "error_history_not_found"
		case "error_insufficient_permissions": 
			return "error_insufficient_permissions"
		case "error_message_ident_not_found": 
			return "error_message_ident_not_found"
		case "error_missing_file": 
			return "error_missing_file"
		case "error_notification_for_object_already_exists": 
			return "error_notification_for_object_already_exists"
		case "error_notification_not_found": 
			return "error_notification_not_found"
		case "error_offer_not_found": 
			return "error_offer_not_found"
		case "error_offercategory_in_use": 
			return "error_offercategory_in_use"
		case "error_offercategory_not_found": 
			return "error_offercategory_not_found"
		case "error_public_after_in_the_past": 
			return "error_public_after_in_the_past"
		case "error_slug_taken": 
			return "error_slug_taken"
		case "error_token_expired": 
			return "error_token_expired"
		case "error_track_not_found": 
			return "error_track_not_found"
		case "error_track_taken": 
			return "error_track_taken"
		case "error_unauthorized": 
			return "error_unauthorized"
		case "error_unknown_provider": 
			return "error_unknown_provider"
		case "error_user_exists": 
			return "error_user_exists"
		case "error_user_not_found": 
			return "error_user_not_found"
		case "RequiredStringValidator: article/category": 
			return "Nie wybrano kategorii."
		default:
			return error
	}
}